import script from "./InputQuantity.vue?vue&type=script&setup=true&lang=js"
export * from "./InputQuantity.vue?vue&type=script&setup=true&lang=js"

import "./InputQuantity.vue?vue&type=style&index=0&id=9397fffa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9397fffa"]])

export default __exports__